export default {
  // List loading state (drives the group pickers' loaders)
  loading: false,
  list: [],
  dialog: false,
  isEditting: false
}